import { Typography } from "@stardust-ds/react";
import ArrowRightIcon from "../../../assets/icons/ArrowRightIcon";
import styles from './index.module.scss'


export default function RcmpSteps(props) {
    const { aData, nStep } = props
    return (
        <ul className={styles.stepsContainer}>
            {aData.map((data, index) => {
                return (
                    <li className={styles.step} key={index}>
                        <div className={nStep === index + 1 ? styles.stepNumber : styles.stepNumberDisabled}>
                            <p>{index + 1}</p>
                        </div>
                        <Typography type="l2" color={nStep === index + 1 ? "#6CB6E3" : "#ACB4BA"}>{data}</Typography>
                        {index + 1 !== aData.length && <ArrowRightIcon fill={"#ACB4BA"} />}
                    </li>
                )
            })}

        </ul>
    )
}